import { registerJsAddProductEvent } from "../../libs/ts/utils";
export function registerAddProduct(cart, btnSelector = ".js-add-product", qtyValueSelector = ".js-qty-selector") {
    const attachedClass = "js-add-event-attached";
    const objects = document.querySelectorAll(`${btnSelector}:not(${attachedClass}`);
    objects.forEach(addBtn => {
        registerJsAddProductEvent(cart, addBtn, qtyValueSelector, attachedClass);
    });
}
